/**
 * @param {string} url
 * @param {{ name: string, value: string }[]} query
 * @returns {string}
 */
export default function addUrlQuery(url, query) {
    if (typeof url !== 'string') {
        throw new Error(`${addUrlQuery.name}: ${url} is not a string`);
    }

    if (!Array.isArray(query)) {
        throw new Error(`${addUrlQuery.name}: ${query} is not a collection`);
    }

    const urlObj = new URL(url);
    query.forEach(
        ({ name, value }) => urlObj.searchParams.set(name, value),
    );
    return urlObj.toString();
}
